import axios from "axios";
import { get_tax_settings_list, tax_filtered_list } from "../../../Redux/Settings/TaxSettings/taxSettingsSlice";
import store from "../../../Redux/store";
import { HEADERS } from "../../UrlAndPaths";
import { setSubmitLoading } from "../../../Redux/Dashboard/mainDashBoardSlice";

export const getAllTaxSettingsListAPICall = () => {
  axios
    .post("settings/taxList", {}, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        store.dispatch(get_tax_settings_list({ taxSettingsData: res.data }));
      }
    })
    .catch((err) => {
      console.log(err.response);
    });
};
export const TaxSettingsFilterAPICall =(body,setIsLoading)=>{
  setIsLoading!==undefined&&setIsLoading(true)

  axios.post("settings/searchtaxList",body,HEADERS)
  .then((res)=>{
    if(res.status===200){
      store.dispatch(tax_filtered_list({filteredListTax:res.data}))
      setIsLoading!==undefined&&setIsLoading(false)
    }
  })
  .catch((err)=>{
    store.dispatch(tax_filtered_list({filteredListTax:undefined}))
    setIsLoading!==undefined&&setIsLoading(false)
  })

}
// addTaxsettings 
export const createTaxSettingsApicall = (
  addCreateTax,
  setState,
  state,
  setCreateTax
) => {
  store.dispatch(setSubmitLoading(true))
  axios
  .post("settings/createTax", addCreateTax, HEADERS)
  
  .then((res) => {
    if (res.status === 200) {
        store.dispatch(setSubmitLoading(false))
        setState({...state,message:"Created Success fully !!",success:true})
        setCreateTax(false);
      }
    })
    .catch((err) => {
      store.dispatch(setSubmitLoading(false))
      if(err.response.status === 500){
        setState({...state,message:"Internal Server error !",error:true})
      }
      else{
        setState({...state,message:err?.response?.data,error:true})
      }
    });
};

//updateTaxSettingsApiCall
export const updateTaxSettingsApiCall = (
  body,
  setState,
  state,
  setConfEditShow,
  setDisabledInput,
  setTaxStatus,
  TaxStatus,
  setCreateTax
) => {
  store.dispatch(setSubmitLoading(true))
  axios
    .put("settings/editTax", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        setState({...state,message:"Updated Successfully !!",success:true})
        store.dispatch(setSubmitLoading(false))
        setDisabledInput(true)
        setConfEditShow(false)
        if (setTaxStatus) setTaxStatus(!TaxStatus)
        if (setCreateTax) setCreateTax(false)
      }
    })
    .catch((err) => {
      store.dispatch(setSubmitLoading(false))
      if(err.response.status === 500){
        setState({...state,message:"Internal Server error !",error:true})
      }
      else{
        setState({...state,message:err?.response?.data,error:true})
      }
    });
};

// UpdateTaxStatusAPiCall
// deleteTaxApiCall
export const deleteTaxApiCall = (
  id,
  setSnackBarStates,
  snackBarStates,
  setTaxStatus,
  TaxStatus
) => {
  store.dispatch(setSubmitLoading(true));
  axios
    .post("settings/deleteTax", { _id: id }, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        store.dispatch(setSubmitLoading(false));
        setSnackBarStates({ ...snackBarStates, message: "Tax deleted successfully!", success: true });
        if (setTaxStatus) setTaxStatus(!TaxStatus);
      }
    })
    .catch((err) => {
      store.dispatch(setSubmitLoading(false));
      if (err.response?.status === 406) {
        setSnackBarStates({ ...snackBarStates, message: err?.response?.data, error: true });
      } else if (err.response?.status === 500) {
        setSnackBarStates({ ...snackBarStates, message: "Internal Server error!", error: true });
      } else {
        setSnackBarStates({ ...snackBarStates, message: err?.response?.data || "Delete failed", error: true });
      }
    });
};

// checkTaxUsageApiCall
export const checkTaxUsageApiCall = (taxIds, setTaxUsageMap) => {
  axios
    .post("settings/checkTaxUsage", { taxIds }, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        setTaxUsageMap(res.data);
      }
    })
    .catch((err) => {
      console.error("checkTaxUsage error:", err);
    });
};

export const UpdateTaxStatusAPiCall = (id,status,setTaxStatus,TaxStatus,setLoadingForm,FormDataInfo,currentPage) => {
  console.log(status)
  setLoadingForm!==undefined && setLoadingForm(true)
  axios
    .post(
      "settings/updateTaxStatus",
      {
        id: id,
        status: !status,
      },
      HEADERS
    )
    .then((res) => {
      if(res.status === 200){
        console.log(res.data)
        setTaxStatus(!TaxStatus)
        setLoadingForm!==undefined && setLoadingForm(false)
        if (FormDataInfo) {
          TaxSettingsFilterAPICall({
            status:
              FormDataInfo.status?.length !== 0
                ? FormDataInfo.status?.[0] === "ACTIVE"
                  ? true
                  : false
                : null,
            search: FormDataInfo.search,
            index: (currentPage || 1) - 1,
          });
        }
      }
    })
    .catch((err) => {
      window.alert("ERROR OF STATUS UPDATE>>>")
      setLoadingForm!==undefined && setLoadingForm(false)
    });
};
